<form novalidate (submit)="validateCoupon()" class="form-coupon">
  <div class="coupon-input">
    <pxw-text-field
      class="coupon-input-field"
      label="Código de descuento"
      placeholder="Ingrese el código de descuento"
      [disabled]="validatingCoupon"
      [(value)]="promotionCodeInput"
      >
      <div class="addon-append">
        @if (!promotionCodeInfo) {
          <pxw-button
            class="coupon-input-button"
            color="yellow"
            [loading]="validatingCoupon"
            (click)="validateCoupon()"
            [rounded]="true"
            size="md"
            >
            Validar
          </pxw-button>
        }
        @if (promotionCodeInfo) {
          <pxw-icon
            class="coupon-remove-button danger ui-clickable"
            icon="close"
            (click)="removeCoupon()"
          ></pxw-icon>
        }
      </div>
    </pxw-text-field>
  </div>
  @if (promotionCodeInfo) {
    <pxw-alert type="info" size="sm" class="promotion-code-alert"
      ><strong>Cupón aplicado con éxito: </strong>
      @if (billingType === 'MONTLY') {
        <span
          >{{ promotionCodeInfo.discount }}% de descuento
          {{
          promotionCodeInfo.recurring_profit === 1
          ? 'en el primer mes'
          : 'durante ' + promotionCodeInfo.recurring_profit + ' meses'
          }}.</span
          >
        }
        @if (billingType === 'YEARLY') {
          <span
            >{{ promotionCodeInfo.discount }}% de descuento por única vez.</span
            >
            }</pxw-alert
            >
          }
        </form>
